import { LightningElement, api, wire } from "lwc";
import { c as classNames } from "tds/chunk_index";
import { LabelsAdapter } from "common/labelsAdapter";
import { MenuAdapter } from "common/menuAdapter";
import { attrToBool } from "common/helpers";

var data$9 = { more: "Weitere Optionen" };
data$9.more;

var data$8 = { more: "More Options" };
data$8.more;

var data$7 = { more: "Más opciones" };
data$7.more;

var data$6 = { more: "Más opciones" };
data$6.more;

var data$5 = { more: "Plus d'options" };
data$5.more;

var data$4 = { more: "Altre opzioni" };
data$4.more;

var data$3 = { more: "他のオプション" };
data$3.more;

var data$2 = { more: "옵션 더 보기" };
data$2.more;

var data$1 = { more: "Mais opções" };
data$1.more;

var data = { more: "更多选项" };
data.more;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

let ActionButtons = /*#__PURE__*/ (function (ActionButtons) {
  ActionButtons["PRIMARY"] = "PRIMARY";
  ActionButtons["MORE_ACTIONS"] = "MORE_ACTIONS";
  return ActionButtons;
})({});
class actionsMenu extends LightningElement {
  @api action = null;
  @api actions = [];
  @api contentType = "";
  @api setFocusOnButton(actionType, name) {
    let buttonForFocus = null;
    if (actionType === ActionButtons.PRIMARY) {
      const buttonName = name ? name : this.primaryActions[0].name;
      buttonForFocus = this.template.querySelector(
        `.buttons > [data-key='${buttonName}']`
      );
    } else if (actionType === ActionButtons.MORE_ACTIONS) {
      buttonForFocus = this.template.querySelector(
        '.buttons > div > button[data-key="more-dropdown"]'
      );
    }
    buttonForFocus?.focus();
  }
  @api get open() {
    return this.menu.state.open;
  }
  set open(value) {
    attrToBool(value) ? this.menu.open() : this.menu.close();
  }
  @wire(LabelsAdapter, {
    locales,
  })
  labels = null;
  get actionsFlattened() {
    return this.actions.flatMap((s) => s.actions);
  }
  get hasActions() {
    return this.actionsFlattened.length > 0;
  }
  @api focus() {
    this.template.querySelector(".buttons")?.firstChild?.focus();
  }
  @wire(MenuAdapter, {
    items: "$actionsFlattened",
    template: "$template",
  })
  menu = null;
  get shouldRenderDropdown() {
    return this.contentType !== "learningpath";
  }
  get primaryActions() {
    const actions = [this.action].flat().filter(Boolean);
    return actions.map((action) => ({
      ...action,
      renderButtonIcon: action.icon && !action.showLabel,
      iconSymbol: action.showLabel ? action.icon?.symbol : undefined,
      className: classNames(
        "action--primary",
        action.disabled && "action--primary-disabled"
      ),
    }));
  }
  get sections() {
    return this.actions.map((section, index) => {
      return {
        ...section,
        key: `section-${index}`,
        actions: section.actions.map((action) => ({
          ...action,
          handler: () => {
            this.dispatchEvent(
              new CustomEvent("action", {
                detail: action,
              })
            );
          },
        })),
      };
    });
  }
  get triggerClassName() {
    return classNames("trigger button button--bare button--small", {
      "trigger--action": this.action,
      "trigger--hide": !this.hasActions,
    });
  }
  handlePrimaryAction() {
    this.setFocusOnButton(ActionButtons.PRIMARY);
    this.dispatchEvent(
      new CustomEvent("action", {
        detail: this.action,
      })
    );
  }
}

export default actionsMenu;
export { ActionButtons };
